import React from 'react';

/* ==================================================================
   ActionButton
   ------------------------------------------------------------------
   One button that moves through idle -> pending -> done rather than
   three buttons swapped out under the cursor. The label is keyed on
   the state so React remounts just that span and the swap animation
   replays, while the button box itself transitions its colours - the
   control never jumps or reflows the row it sits in.

     <ActionButton state={state} labels={{idle:'Apply Now', …}} />
   ================================================================== */

const DEFAULT_LABELS = {
  idle: 'Apply Now',
  pending: 'Applying…',
  done: 'Applied',
};

function Tick() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" aria-hidden="true">
      <polyline className="ui-tick-draw" points="20 6 9 17 4 12" />
    </svg>
  );
}

export default function ActionButton({
  state = 'idle',
  labels,
  onClick,
  size = 'sm',
  disabled = false,
  className = '',
  style,
  type = 'button',
}) {
  const text = { ...DEFAULT_LABELS, ...labels };
  const busy = state === 'pending';
  const done = state === 'done';

  return (
    <button
      type={type}
      className={`ui-action ui-action--${size} ui-action--${state} ${className}`.trim()}
      style={style}
      onClick={done || busy ? undefined : onClick}
      disabled={disabled || busy || done}
      aria-live={busy || done ? 'polite' : undefined}
    >
      <span className="ui-action__label" key={state}>
        {busy && <span className="ui-spin" aria-hidden="true" />}
        {done && <Tick />}
        {text[state]}
      </span>
    </button>
  );
}
